// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1WD1e","header":"ReportDetails_header__2wI7B","title":"ReportDetails_title__1kMHZ","left":"ReportDetails_left__22dWD"};